import { useCallback } from 'react';
import { NavigateOptions, useNavigate } from 'react-router-dom';
import { URL_SEARCH_PARAM_KEY } from '../constant/UrlSearchParams.constant';
import { addSearchParam } from '../utils/SearchParam.Utils';

export const useNavigateWithSearchParam = () => {
  const reactRouterNavigate = useNavigate();

  // Wrapper around navigate hook of react-router-dom
  const navigate = useCallback(
    (url: string, navigateOptions?: NavigateOptions) => {
      reactRouterNavigate(url, navigateOptions);
    },
    [reactRouterNavigate],
  );

  // Custom hook to add companyId param as search param to url
  // @deprecated use navigateWithSearchParams instead
  const navigateWithCompanyId = useCallback(
    (url: string, companyId: string | null | undefined, navigateOptions?: NavigateOptions) => {
      navigate(
        `${addSearchParam(url, URL_SEARCH_PARAM_KEY.COMPANY_ID, companyId || '')}`,
        navigateOptions,
      );
    },
    [navigate],
  );

  // Custom hook to add multiple search params to url
  const navigateWithSearchParams = (
    url: string,
    searchParams: Record<string, string | null | undefined>,
    navigateOptions?: NavigateOptions,
  ) => {
    const urlObj = new URL(url, window.location.origin);

    Object.entries(searchParams).forEach(([key, value]) => {
      if (value !== null && value !== undefined && value !== '') {
        urlObj.searchParams.set(key, value);
      }
    });

    navigate(urlObj.pathname + urlObj.search, navigateOptions);
  };

  return { navigateWithSearchParams, navigateWithCompanyId, navigate };
};
